import React from 'react';
import { movdTokens } from './movdTokens.js';

const dateLabel = value => value ? new Date(`${String(value).split('T')[0]}T12:00:00`).toLocaleDateString('en-CA', { month: 'short', day: 'numeric' }).toUpperCase() : 'DATE TBD';
const formatPrice = value => {
  const amount = typeof value === 'string' ? Number(value.replace(/[^\d.-]/g, '')) : Number(value);
  return Number.isFinite(amount) ? `$${amount.toLocaleString('en-CA')}` : 'Unavailable';
};

export default function MovdMoveProfile({ move, dark = false, selectedMover }) {
  const foreground = dark ? movdTokens.color.text : movdTokens.color.ink;
  const muted = dark ? 'rgba(248,250,252,.62)' : '#53636A';
  const border = dark ? 'rgba(248,250,252,.18)' : '#DCE8E4';
  const inventory = Array.isArray(move?.inventory) ? move.inventory : Array.isArray(move?.inventory?.items) ? move.inventory.items : [];
  const itemCount = inventory.reduce((total, item) => total + Number(item.qty ?? item.quantity ?? 1), 0);
  const origin = move?.origin || move?.serviceDetails?.origin || '';
  const destination = move?.destination || move?.serviceDetails?.destination || '';
  const moveDate = move?.moveDate || move?.serviceDetails?.moveDate;
  const moveSize = move?.moveSize || move?.serviceDetails?.moveSize;
  const mover = selectedMover?.company || selectedMover?.name;
  const price = selectedMover?.price;

  return (
    <section aria-label="Your move" style={{ display: 'grid', gap: 14, padding: '18px 0', color: foreground, borderTop: `1px solid ${border}`, borderBottom: `1px solid ${border}` }}>
      <div style={{ color: dark ? movdTokens.color.tealSoft : '#176B60', fontSize: 10, fontWeight: 900, letterSpacing: '.16em' }}>YOUR MOVE</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 28px minmax(0,1fr)', gap: 10, alignItems: 'center' }}>
        <strong style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 17 }}>{origin || 'Pickup location'}</strong>
        <span aria-hidden="true" style={{ color: movdTokens.color.teal, fontSize: 22, textAlign: 'center' }}>→</span>
        <strong style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 17 }}>{destination || 'Drop-off location'}</strong>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 18px', color: muted, fontSize: 12, fontWeight: 800 }}>
        <span>{dateLabel(moveDate)}</span>
        <span>{moveSize || 'MOVE SIZE TBD'}</span>
        <span>{itemCount ? `${itemCount} ITEMS` : 'QUICK QUOTE'}</span>
        {mover && <span>{mover.toUpperCase()}</span>}
        {price != null && <span>{formatPrice(price)}</span>}
      </div>
    </section>
  );
}
